// Simple Cart Control - Hide digital quantity selectors
document.addEventListener('DOMContentLoaded', function() {
  hideDigitalQuantities();
  
  // Listen for cart updates when items are deleted
  document.addEventListener('cart:updated', function() {
    setTimeout(hideDigitalQuantities, 100);
  });
  
  // Also watch for DOM changes
  const observer = new MutationObserver(function() {
    hideDigitalQuantities();
  });
  
  const cartContainer = document.querySelector('#main-cart-items, .cart');
  if (cartContainer) {
    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }
});

function hideDigitalQuantities() {
  // Find digital products
  const digitalItems = document.querySelectorAll('tr.cart-item[data-requires-shipping="false"]');
  
  digitalItems.forEach(function(item) {
    // Hide quantity controls
    const quantityControls = item.querySelectorAll('quantity-input, .quantity__input, .quantity__button');
    quantityControls.forEach(function(control) {
      control.style.display = 'none';
    });
    
    // Add "Digital Download" text if not already added
    const wrapper = item.querySelector('.cart-item__quantity-wrapper');
    if (wrapper && !wrapper.querySelector('.digital-download-text')) {
      // Style wrapper for LEFT alignment
      wrapper.style.display = 'flex';
      wrapper.style.alignItems = 'center';
      wrapper.style.justifyContent = 'flex-start';
      wrapper.style.gap = '0.5rem';
      
      const text = document.createElement('div');
      text.className = 'digital-download-text';
      text.textContent = 'DIGITAL\nDOWNLOAD';
      text.style.cssText = `
        font-size: 1.0rem; 
        color: #374151; 
        font-weight: bold; 
        text-transform: uppercase; 
        letter-spacing: 0.4px; 
        white-space: pre-line; 
        text-align: center; 
        line-height: 1.1;
        border: 1px solid rgba(0,0,0,0.1);
        border-radius: 4px;
        background-color: #f9f9f9;
        padding: 8px 10px;
        width: 140px;
        min-height: 44px;
        max-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        box-sizing: border-box;
      `;
      
      // Insert at the beginning of wrapper
      wrapper.insertBefore(text, wrapper.firstChild);
      
      // Ensure remove button has no extra margin
      const removeButton = wrapper.querySelector('cart-remove-button');
      if (removeButton) {
        removeButton.style.flexShrink = '0';
        removeButton.style.marginLeft = '0';
      }
    }
  });
}